import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { first } from 'rxjs';

import { ApplicationRole } from '@bn/primitives';
import { UserDetails } from '@bn/shared/core/api';

import { MENU_ACCESS } from './menu-access.token';

/**
 *
 * Usage examples:
 *
 * On html elements:
 *
 *    <ng-container *roleIds="['SubuserManage']">
 *
 * Menu item and its children:
 *
 *    {
 *      name: 'Compute',
 *      roleIds: ['SubuserManage']
 *      children: [{
 *          name: 'Scripts',
 *          icon: ['fad', 'code'],
 *          route: AppRoutes.Script,
 *          roleIds: ['SubuserManage']
 *      }],
 *    }
 *
 */

@Directive({
  selector: '[roleIds]',
})
export class UserPermissionsDirective {
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<ViewContainerRef>>(TemplateRef);
  private readonly access = inject(MENU_ACCESS, { optional: true });

  @Input()
  public set roleIds(currentRoleIds: ApplicationRole[] | undefined) {
    if (!currentRoleIds || !this.access) {
      this.viewContainer.createEmbeddedView(this.templateRef);

      return;
    }

    this.access
      .getUserDetails()
      .pipe(first())
      .subscribe((userDetails: UserDetails | null) => {
        const roles = userDetails?.Roles || [];
        const foundAny = currentRoleIds.some((r) => roles.indexOf(r) >= 0);

        if (foundAny || (roles.includes('User') && !currentRoleIds.includes('Agent'))) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
